import React from "react";

import {
  Field,
  FieldLabel,
  TwoColumnRow,
} from "../../../../components/FormPanel";
import { FormInput } from "../../../../components/Input";
import { EXCHANGE_RULES } from "./constants";
import { SymbolField } from "./SymbolField";
import { EditorFieldsProps } from "./types";

export const SymbolExchangeRow: React.FC<EditorFieldsProps> = ({
  control,
  disabled,
}) => (
  <TwoColumnRow>
    <SymbolField control={control} disabled={disabled} />
    <Field>
      <FieldLabel htmlFor="instrument-editor-exchange">Exchange</FieldLabel>
      <FormInput
        id="instrument-editor-exchange"
        name="exchange"
        control={control}
        rules={EXCHANGE_RULES}
        disabled={disabled}
      />
    </Field>
  </TwoColumnRow>
);
